import type { RailItemId } from './types'

/**
 * The rail item a session starts on, as data — a dependency-free leaf.
 *
 * It lives here rather than beside `RAIL_ITEMS` because `./types` pulls in
 * `lucide-react` for its icons, and the store's project-exit path
 * (`store/project-session-exit.ts`) needs this value without dragging an icon
 * pack — and without widening the `project-slice -> studio-store` import
 * cycle that `store/__tests__/project-slice-circular-import.test.ts` guards.
 * The type import above is erased at build time.
 *
 * ONE source for two consumers: `store/ide-v2-slice.ts` starts here, and
 * `store/project-session-exit.ts` returns here. `activeRailItem` names an IDE
 * surface, and no IDE surface exists with no project open — slice-5A §A5-a
 * measured `data` still selected on the dashboard after the project was left.
 */
export const INITIAL_ACTIVE_RAIL_ITEM: RailItemId = 'preview'
